import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCode, FiDatabase, FiServer, FiGlobe } = FiIcons;

const About = () => {
  const highlights = [
    {
      icon: FiCode,
      title: 'Frontend Development',
      description: 'Expert in React.js, JavaScript, and modern frontend frameworks'
    },
    {
      icon: FiServer,
      title: 'Backend Development',
      description: 'Proficient in Spring Boot, Python, and RESTful API development'
    },
    {
      icon: FiDatabase,
      title: 'Database Management',
      description: 'Strong knowledge of SQL, database design, and optimization'
    },
    {
      icon: FiGlobe,
      title: 'Full Stack Integration',
      description: 'Experience in building complete web applications end-to-end'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-gray-900 mb-4">
            About Me
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A passionate Full Stack Developer with expertise in modern web technologies
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="prose prose-lg text-gray-600">
              <p className="mb-6">
                I'm a dedicated Full Stack Developer with a strong foundation in both frontend and backend technologies. 
                My passion lies in creating efficient, scalable web applications that provide exceptional user experiences.
              </p>
              <p className="mb-6">
                With expertise in React.js, Spring Boot, Python, and SQL, I enjoy working across the entire development 
                stack to bring ideas to life. I'm constantly learning and adapting to new technologies to stay current 
                with industry trends.
              </p>
              <p>
                When I'm not coding, I enjoy exploring new technologies, contributing to open-source projects, and 
                sharing knowledge with the developer community.
              </p>
            </div>
          </motion.div>

          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 gap-6"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            {highlights.map((item, index) => (
              <motion.div
                key={index}
                className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300"
                whileHover={{ y: -5 }}
              >
                <div className="text-primary-600 mb-4">
                  <SafeIcon icon={item.icon} className="w-8 h-8" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;